import axios from 'axios';

export const CountersApi = {
  getCount: (filter) => axios.get(
    `/api/public/info/count/kindergarten?filter=${filter}`
  ),
  getCountAdditionalEducationOrgSC: (filter) => axios.get(
    `/api/public/info/count/addition/education?filter=${filter}`
  ),
};
